module.exports = __webpack_public_path__ + "img/marker.212732d4.svg";